<template>
    <div
        v-if="investorsDataIsLoading || investorsData"
        class="i-bonds__component">
        <loader v-if="investorsDataIsLoading" />
        <obligations-block
            v-if="investorsData"
            :data="investorsData.data"
            :is-several-rows="true" />
    </div>
</template>

<script>
    import Loader from '../vue-components/Loader'
    import ObligationsBlock from '../vue-components/ObligationsBlock'
    import { investorsDataActionTypes } from '../store/modules/investors/investors'
    import { mapState } from 'vuex'

    export default {
        name: 'BankDomrfBonds',
        components: {
            Loader,
            ObligationsBlock
        },
        computed: {
            ...mapState({
                investorsDataIsLoading: state => state.investorsData.isLoading,
                investorsData: state => state.investorsData.data,
                investorsDataError: state => state.investorsData.error,
            }),
        },
        data() {
            return {
                apiUrl: '/api/v2/content/investors/',
            }
        },
        beforeMount() {
            this.apiUrl += document.querySelector('#app').getAttribute('data-api')
            this.$store.dispatch(investorsDataActionTypes.getInvestorsData, {apiUrl: this.apiUrl})
        },
    }
</script>